
import $config from '../../config'
/**
 * 根据域名返回微信分享设置的字段
 * @return String
 */
export const getWXSys = () => {
    console.log('$config.host :>> ', $config.host);
    if($config.host.indexOf('shencai') != -1) {
        return 'wj'
    } else if($config.host.indexOf('mlxy') != -1){
        return 'wjmlxy'
    }
    return 'wj'
}